class ProfilerAnswer {
    id;
    optionValueId;
    questionOptionId;
    constructor(data) {
        this.id = data.id;
        this.optionValueId = data.optionValueId;
        this.questionOptionId = data.questionOptionId;
    }
}
export default ProfilerAnswer;
